import { Icon } from '@chakra-ui/react';

export default function SFChatBubbleIcon(props) {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      width={7}
      height={7}
      fill='none'
      viewBox='0 0 28 18'
      {...props}
    >
      <path
        d='M9.5612 24.4362C8.92317 24.4362 8.56771 23.9805 8.56771 23.2786V20.9089H8.13021C5.41406 20.9089 3.95573 19.4141 3.95573 16.7344V9.7526C3.95573 7.07292 5.41406 5.57812 8.13021 5.57812H19.8698C22.5859 5.57812 24.0443 7.08203 24.0443 9.7526V16.7344C24.0443 19.4049 22.5859 20.9089 19.8698 20.9089H14.0182L10.8737 23.707C10.3177 24.1992 10.0078 24.4362 9.5612 24.4362ZM9.93489 22.7682L12.8516 19.8698C13.1979 19.5143 13.4531 19.4414 13.9635 19.4414H19.8698C21.7018 19.4414 22.5768 18.5026 22.5768 16.7253V9.7526C22.5768 7.97526 21.7018 7.04557 19.8698 7.04557H8.13021C6.28906 7.04557 5.42317 7.97526 5.42317 9.7526V16.7253C5.42317 18.5026 6.28906 19.4414 8.13021 19.4414H9.2513C9.74349 19.4414 9.93489 19.6328 9.93489 20.125V22.7682Z'
        fill='currentColor'
      />
    </Icon>
  );
}
